export default __webpack_public_path__ + "static/media/pwc.e0ca2142.svg";